<template>
	<div class=" ">
		<el-card>
			<div class="add_main_new hidden_scroll">
				<div class="sub_content_left hidden_scroll">
					<div class="">
						<el-form
							label-position="right"
							label-width="120px"
							:model="formData"
							:rules="rule"
							ref="formData"
						>
							<span class="add_item_title">文章信息</span>
							<el-form-item label="文章类型" prop="type">
								<el-radio
									v-model="formData.type"
									label="1"
									:disabled="$route.query.type == 'detail'"
									@change="handletypeChange"
								>
									文章
								</el-radio>
								<el-radio
									v-model="formData.type"
									label="2"
									:disabled="$route.query.type == 'detail'"
									@change="handletypeChange"
								>
									快讯
								</el-radio>
								<el-radio
									v-model="formData.type"
									label="5"
									:disabled="$route.query.type == 'detail'"
									@change="handletypeChange"
								>
									专栏
								</el-radio>
							</el-form-item>
							<!-- 非快讯类型：显示传统分类 -->
							<el-form-item
								label="资讯分类"
								prop="category_id"
								v-if="formData.type != '2'"
							>
								<el-radio
									v-model="formData.category_id"
									:label="item.id"
									:disabled="$route.query.type == 'detail'"
									v-for="(item, index) in categoryList_show"
									:key="index"
								>
									{{ item.name }}
								</el-radio>
							</el-form-item>

							<!-- 快讯分类新逻辑 -->
							<div v-if="formData.type == '2'">
								<!-- 业务分类选择 -->
								<el-form-item
									label="业务分类"
									prop="category_id"
									class="business-category-group"
								>
									<el-radio-group v-model="formData.category_id">
										<el-radio
											v-for="item in categoryList_show"
											:key="item.id"
											:label="item.id"
											:disabled="$route.query.type == 'detail'"
										>
											{{ item.name }}
										</el-radio>
									</el-radio-group>
									<p class="form_tip"></p>
								</el-form-item>

								<!-- 重要快讯标记 -->
								<el-form-item label="重要快讯">
									<el-switch
										v-model="formData.is_important_flash"
										:active-value="1"
										:inactive-value="0"
										:disabled="$route.query.type == 'detail'"
										active-text="是"
										inactive-text="否"
									>
									</el-switch>
									<p class="form_tip">标记为重要快讯后会在重要快讯栏目显示</p>
								</el-form-item>
							</div>

							<el-form-item label="操作类型">
								<el-radio
									v-model="formData.edit_type"
									:label="item.id"
									:disabled="$route.query.type == 'detail'"
									v-for="(item, index) in editTypeArray"
									:key="index"
								>
									{{ item.name }}
								</el-radio>
							</el-form-item>

							<span class="add_item_title">作者信息</span>
							<el-form-item label="账号类型" prop="userType">
								<el-select
									v-model="userType"
									placeholder=""
									:disabled="$route.query.type == 'detail'"
									@change="handleUserTypeChange"
								>
									<el-option label="内部员工" value="2"> </el-option>
									<el-option label="外部账号" value="1"> </el-option>
								</el-select>
							</el-form-item>
							<el-form-item
								label="作者名称"
								class="margin_top_10"
								prop="author_id"
							>
								<el-select
									v-model="formData.author_id"
									placeholder="请选择作者"
									:disabled="$route.query.type == 'detail'"
									collapse-tags
									clearable
									filterable
								>
									<el-option
										:label="item.nickname"
										:value="item.id"
										v-for="(item, index) in userSelList"
										:key="index"
									>
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item
								class="margin_top_10"
								label="原文作者"
								prop="authorship"
							>
								<el-input
									class="add_left_item_input"
									v-model="formData.original_author"
									:disabled="$route.query.type == 'detail'"
								>
								</el-input>
							</el-form-item>

							<el-form-item
								class="margin_top_10"
								label="原文出处"
								prop="derivation"
							>
								<el-input
									class="add_left_item_input"
									v-model="formData.original_site"
									:disabled="$route.query.type == 'detail'"
								>
								</el-input>
							</el-form-item>

							<el-cascader
								class="add_left_item_cascader"
								placeholder="请选择专区"
								v-model="formData.special_id"
								:options="specialList"
								:disabled="$route.query.type == 'detail'"
								clearable
								filterable
							>
							</el-cascader>

							<div class="add_left_item_zhuanti">
								<div class="add_left_item_zhuanti_header">
									<div class="add_left_item_zhuanti_header_left">
										<div class="add_left_item_zhuanti_header_left_title">
											选择专题
										</div>
										<div class="add_left_item_zhuanti_header_left_count">
											已选({{ this.ticketArray.length }})
										</div>
									</div>
									<div
										class="add_left_item_zhuanti_header_right"
										@click="addZhuanti()"
									>
										+
									</div>
								</div>
								<div
									class="add_left_item_zhuanti_content"
									@click="showZhuanti = true"
								>
									{{
										this.ticketArray.length > 0
											? this.ticketArray
													.map((ticketId) => {
														const label = this.labelList.find(
															(item) => item.id === ticketId,
														);
														return label ? label.name : "";
													})
													.join(",")
											: "请选择专题"
									}}
								</div>

								<el-dialog
									class="add_left_item_zhuanti_dialog"
									title=""
									:visible.sync="showZhuanti"
									width="400px"
									center
									:append-to-body="true"
								>
									<template v-if="showZhuanti">
										<zhuanti
											:ticketArray="ticketArray"
											:labelList="labelList"
											@zhuanti_submit="zhuanti_submit"
											@zhuanti_exit="showZhuanti = false"
										></zhuanti>
									</template>
								</el-dialog>
							</div>

							<el-form-item
								label="封面图片"
								prop="pic"
								class="add_main_item_block"
							>
								<div class="add_main_item_block_img">
									<div class="upload_img_div" v-if="formData.pic">
										<img
											style="width: 80%"
											:src="formData.pic"
											@click="uploadPicture(formData.pic)"
										/>
										<div class="upload_img_del">
											<img
												@click="removePicture"
												src="../../../assets/images/upload_img_del.png"
											/>
										</div>
									</div>

									<div v-else class="upload_img_div_add">
										<img
											src="https://res.me.news/assets/images/web/上传.png"
											alt=""
											@click="uploadPicture(formData.pic)"
										/>
									</div>
								</div>
								<div class="add_main_item_block_img_text">
									请使用清晰度较高的图片，建议尺寸：16:9，图片格式支持：jpg、jpeg和png，图片大小限制：不超过5M
								</div>
								<!-- 剪裁组件弹窗 -->
								<el-dialog
									title=""
									:visible.sync="cropperModel"
									width="1300px"
									center
									:append-to-body="true"
								>
									<template v-if="cropperModel">
										<cropper-image-new
											:Name="cropperName"
											:type="scale"
											@uploadImgSuccess="handleUploadSuccess"
											ref="child"
										>
										</cropper-image-new>
									</template>
								</el-dialog>
							</el-form-item>
							<el-form-item label="原文链接" prop="url" class="margin_top_10">
								<el-input
									class="add_left_item_input"
									v-model="formData.url"
									:disabled="$route.query.type == 'detail'"
								>
								</el-input>
							</el-form-item>
							<el-form-item label="首页置顶">
								<el-radio
									v-model="formData.is_top"
									label="1"
									:disabled="$route.query.type == 'detail'"
									>是</el-radio
								>
								<el-radio
									v-model="formData.is_top"
									label="0"
									:disabled="$route.query.type == 'detail'"
									>否</el-radio
								>
							</el-form-item>
							<el-form-item label="首页展示" v-if="formData.type == 5">
								<el-radio
									v-model="formData.is_home"
									label="1"
									:disabled="$route.query.type == 'detail'"
								>
									是
								</el-radio>
								<el-radio
									v-model="formData.is_home"
									label="0"
									:disabled="$route.query.type == 'detail'"
								>
									否
								</el-radio>
							</el-form-item>
							<el-form-item label="推送tg">
								<el-radio
									v-model="formData.allow_tgpush"
									label="0"
									:disabled="$route.query.type == 'detail'"
									>禁止</el-radio
								>
								<el-radio
									v-model="formData.allow_tgpush"
									label="1"
									:disabled="$route.query.type == 'detail'"
									>允许</el-radio
								>
							</el-form-item>

							<el-form-item
								class="margin_top_10"
								label="发布时间"
								prop="release_time"
							>
								<el-date-picker
									class="add_left_item_input"
									v-model="formData.release_time"
									:disabled="$route.query.type == 'detail'"
									value-format="yyyy-MM-dd HH:mm:ss"
									format="yyyy-MM-dd HH:mm:ss"
									type="datetime"
									placeholder=""
								>
								</el-date-picker>
							</el-form-item>

							<el-form-item
								label="操作人:"
								v-if="formData.adminName && formData.adminName.length > 0"
							>
								<div>{{ formData.adminName }}</div>
							</el-form-item>

							<div class="flex justify_content_c align_items_c add_left_submit">
								<el-button
									:disabled="isDisabled"
									type="primary"
									class="custom_btn_width_100"
									@click="submit('formData', 1, 1)"
									v-if="$route.query.type != 'detail'"
								>
									确定
								</el-button>
								<el-button
									class="custom_btn_width_100"
									@click="submit('formData', 0, 1)"
									v-if="$route.query.type != 'detail'"
								>
									保存草稿
								</el-button>
								<el-button class="custom_btn_width_100" @click="back">
									取消
								</el-button>
							</div>
						</el-form>
					</div>
				</div>
				<div class="sub_content_right hidden_scroll">
					<div class="">
						<el-form
							label-position="right"
							label-width="120px"
							:model="formData"
							:rules="rule"
							ref="formData"
						>
							<el-form-item
								label="中文标题"
								prop="title"
								class="add_main_item_block"
							>
								<el-input
									v-model="formData.title"
									:disabled="$route.query.type == 'detail'"
								>
								</el-input>
							</el-form-item>

							<el-form-item
								label="中文摘要"
								prop="illustrate"
								class="add_main_item_block"
							>
								<el-input
									v-model="formData.illustrate"
									:disabled="$route.query.type == 'detail'"
								>
								</el-input>
							</el-form-item>
							<el-form-item label="" class="add_main_item_block">
								<EditorMine
									ref="editorRef"
									:content="formData.content"
									@onEditorChange="onEditorChange"
									class="add_main_editor"
								>
								</EditorMine>
							</el-form-item>

							<!-- AI 解读区块 -->
							<div class="ai_analysis_section">
								<div class="ai_analysis_header">
									<span class="ai_analysis_title">AI 解读</span>
									<el-button
										type="primary"
										:loading="aiGenerating"
										:disabled="
											$route.query.type == 'detail' || !formData.content
										"
										@click="generateAIContent"
									>
										{{ aiGenerating ? "内容生成中" : "内容生成" }}
									</el-button>
								</div>
								<div
									class="ai_content_placeholder"
									v-if="!formData.ai_content && !aiGenerating"
								>
									AI 生成内容区块
								</div>
								<el-input
									v-else
									type="textarea"
									v-model="formData.ai_content"
									:disabled="$route.query.type == 'detail'"
									:autosize="{ minRows: 8, maxRows: 20 }"
									placeholder="AI生成的内容将显示在这里，您可以进行编辑"
									class="ai_content_editor"
								>
								</el-input>
							</div>
						</el-form>
					</div>
				</div>
			</div>
		</el-card>
		<div v-if="loading" class="loading-overlay">
			<div class="spinner"></div>
		</div>
	</div>
</template>

<script>
import { myMixin } from "@/utils/mixin.js";
import { getUserId } from "@/utils/auth";

import EditorMine from "./Editor.vue";

import zhuanti from "./zhuanti.vue";

import {
	getCategoryList,
	addInformation,
	getLabelList,
	getInformationDetail,
	specialList,
	generateAiAnalysis,
	saveAiAnalysis,
	getAiAnalysis,
} from "@/api/article";
import { uploadImage, getUsersList } from "@/api/user";
import { validateNull } from "@/utils/validate";
import { fixHeadingBlocks } from "@/utils/editorUtils";
import { format } from "echarts";

export default {
	mixins: [myMixin],
	name: "",
	components: {
		EditorMine,
		zhuanti,
	},
	data() {
		return {
			props: { multiple: false },
			rule: {
				category_id: [
					{ validator: validateNull, trigger: "change", required: true },
				],
				author_id: [
					{ validator: validateNull, trigger: "change", required: true },
				],
				title: [{ validator: validateNull, trigger: "blur", required: true }],
				illustrate: [{ trigger: "change", required: false }],

				language: [
					{ validator: validateNull, trigger: "change", required: true },
				],
				pic: [{ validator: validateNull, trigger: "change", required: true }],
				content: [{ validator: validateNull, trigger: "blur", required: true }],

				status: [
					{ validator: validateNull, trigger: "change", required: true },
				],
				type: [{ validator: validateNull, trigger: "change", required: true }],

				release_time: [
					{ validator: validateNull, trigger: "change", required: true },
				],
			},
			isDisabled: false, // 按钮是否禁用
			loading: false,
			aiGenerating: false, // AI生成状态
			hasInitialAiContent: false, // 标记编辑时是否已有 AI 内容
			value: "",
			content: "",
			content_en: "",
			tmp_special_id: "",
			ticketArray: [],
			editTypeArray: [
				{
					id: 1,
					name: "PR",
				},
				{
					id: 2,
					name: "人工原创",
				},
				{
					id: 6,
					name: "AI原创",
				},
				{
					id: 3,
					name: "翻译",
				},
				{
					id: 4,
					name: "转载",
				},
				{
					id: 5,
					name: "审核",
				},
				{
					id: 7,
					name: "AI转载",
				},
			],
			userType: "2",
			formData: {
				adminName: "",
				admin_id: "",
				author_id: "",
				category_id: "",
				is_important_flash: 0, // 新增字段
				special_id: "",
				label_id: 0,
				visits_num: 0,
				ticket_id: [],
				title: "",
				title_en: "",
				illustrate: "",
				illustrate_en: "",
				url: "",
				source_id: "",
				language: "1",
				pic: "",
				content: "",
				content_en: "",
				status: 1,
				edit_type: 1,
				type: "",
				prohibit_tran: 0,
				allow_tgpush: 1,
				is_home: "",
				is_recommend: "0",
				is_top: "",
				release_time: "",
				score: "",
				is_push: "",
				original_author: "",
				original_site: "",
				ai_content: "",
			},
			// 专题id
			specialId: "",
			// 资讯分类
			categoryList: [],
			categoryList_show: [],
			// 用户列表
			userList: [],
			userSelList: [],
			// 标签列表
			labelList: [],
			// 资讯详情
			formationDetail: {},
			// 专题数据
			specialList: [],
			//参数
			cropperModel: false,
			cropperName: "",

			showZhuanti: false,
			scale: "0",
			autoSaveTimer: null, // 添加自动保存定时器
		};
	},
	watch: {
		"$route.query.id": [
			function handler1() {
				if (!this.$route.query.id) {
					this.clearFormAdd();
				} else {
					this.getInformationDetail();
				}
			},
		],
	},
	mounted() {
		// 如果是新增模式，启动定时任务
		if (!this.$route.query.id) {
			this.startAutoSaveTimer();
		}
	},
	created() {
		this.getCategoryListFun();
		this.getUsersListFun();
		this.getLabelListFun();
		this.getspecialList();
		if (!this.$route.query.id) {
			this.clearFormAdd();
		} else {
			this.getInformationDetail();
		}
	},
	methods: {
		// 启动自动保存定时器
		startAutoSaveTimer() {
			console.log("启动自动保存定时器");
			this.autoSaveTimer = setInterval(() => {
				// 检查标题长度是否大于10
				if (this.formData.title && this.formData.title.length > 10) {
					console.log("标题长度大于10", this.formData.title);
					//this.submit("formData", 0, 0);
				}
			}, 60000);
		},
		// 清除自动保存定时器
		clearAutoSaveTimer() {
			if (this.autoSaveTimer) {
				clearInterval(this.autoSaveTimer);
				this.autoSaveTimer = null;
			}
		},

		zhuanti_submit(ticketArray) {
			console.log(ticketArray);
			this.ticketArray = ticketArray;
			this.showZhuanti = false;
		},
		addZhuanti() {
			this.$router.push({ path: "/message/addLabel" });
		},
		removePicture() {
			this.formData.pic = "";
		},
		//封面设置
		uploadPicture(name) {
			if (this.$route.query.type == "detail") {
				// 详情不支持编辑图片
			} else {
				this.cropperName = name;
				this.type = "1";
				this.cropperModel = true;
			}
		},
		//图片上传成功后
		handleUploadSuccess(data) {
			this.cropperModel = false;
			if (
				this.cropperName != null &&
				this.cropperName.indexOf("blob:http") != -1
			) {
				this.handleSuccess(data);
			} else {
				this.formData.pic = data.url;
			}
		},
		// 资讯分类列表
		getCategoryListFun() {
			const that = this;
			getCategoryList({ size: 100 })
				.then((res) => {
					if (res.code == 200) {
						that.categoryList = res.data.data;
						that.categoryList.forEach((item) => {
							item.id = item.id.toString();
						});
					} else {
						that.categoryList = [];
					}
					that.getDefaultCate(that.formData.type);
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		handleSuccess(data) {
			// 获取富文本组件实例
			let quill = this.$refs.QuillEditor.quill;
			if (data) {
				// 如果上传成功
				// 获取光标所在位置
				// let length = quill.getSelection().index;
				let length = 0;
				if (quill.getSelection() && quill.getSelection().index) {
					length = quill.getSelection().index;
				} else {
					length = 0;
				}
				// 插入图片，res为服务器返回的图片链接地址
				quill.insertEmbed(length, "image", data.url);
				// 调整光标到最后
				quill.setSelection(length + 1);
			} else {
				// 提示信息
				this.$message.error("图片插入失败");
			}
		},

		// 获取用户列表
		getUsersListFun() {
			const that = this;
			getUsersList({ type: 1, size: 900 })
				.then((res) => {
					if (res.code == 200) {
						that.userList = res.data.list;
						that.getUserType();
					} else {
					}
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		// 获取标签列表
		getLabelListFun() {
			const that = this;
			getLabelList({})
				.then((res) => {
					if (res.code == 200) {
						that.labelList = res.data.data;
					} else {
					}
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		// 新增资讯提交
		submit(formName, status, isExit) {
			this.$refs.editorRef.clearSearch();
			let ticket_id = "";
			let formData = this.formData;
			// let formData = { ...this.formData };

			if (status == 0) {
			} else {
				if (!formData.title || formData.title.length < 2) {
					this.$message.error("请编辑中文标题");
					return;
				}
				if (
					(!formData.illustrate || formData.illustrate.length < 2) &&
					formData.type != 2
				) {
					this.$message.error("请编辑中文摘要");
					return;
				}
				if (!formData.type || formData.type.length == 0) {
					this.$message.error("请选择文章类型");
					return;
				}
				if (!formData.category_id || formData.category_id.length == 0) {
					this.$message.error("请选择资讯分类");
					return;
				}
				if ((!formData.pic || formData.pic.length < 2) && formData.type != 2) {
					this.$message.error("请上传封面图片");
					return;
				}
				if (!formData.release_time || formData.release_time.length < 2) {
					this.$message.error("请选择发布时间");
					return;
				}
				if (!formData.author_id || formData.author_id.length == 0) {
					this.$message.error("请选择作者");
					return;
				}
			}

			this.isDisabled = true; // 禁用按钮
			// 设置一定时间后重新启用按钮
			setTimeout(() => {
				this.isDisabled = false;
			}, 1000); // 1秒后恢复可点击

			if (this.ticketArray) {
				console.log("this.ticket_id:", this.ticketArray);

				if (this.ticketArray.includes(",")) {
					ticket_id = this.ticketArray;
				} else {
					this.ticketArray.forEach((item) => {
						ticket_id += item + ",";
					});
				}
			}
			formData.ticket_id = ticket_id;
			if (formData.type == 2) {
				this.rule.pic[0].required = false;
			} else {
				this.rule.pic[0].required = true;
			}
			if (
				(formData.title && formData.title.length > 500) ||
				(formData.title_en && formData.title_en.length > 500)
			) {
				this.$message.error("标题过长，请输入500以内内容");
				return;
			} else if (formData.illustrate && formData.illustrate.length > 500) {
				this.$message.error("摘要过长，请输入500以内内容");
				return;
			} else if (formData.pic && formData.pic.length > 1000) {
				this.$message.error("图片链接过长，请输入1000以内内容");
				return;
			} else if (formData.examine_desc && formData.examine_desc.length > 255) {
				this.$message.error("审核理由过长，请输入255以内内容");
				return;
			} else if (formData.url && formData.url.length > 500) {
				this.$message.error("原文链接过长，请输入500以内内容");
				return;
			}
			if (this.content.length > 0) {
				this.formData.content = this.content;
			}
			if (this.content_en.length > 0) {
				this.formData.content_en = this.content_en;
			}
			// 保存前修复标题块，防止重新加载时标题合并
			if (this.formData.content) {
				this.formData.content = fixHeadingBlocks(this.formData.content);
			}
			if (this.formData.content_en) {
				this.formData.content_en = fixHeadingBlocks(this.formData.content_en);
			}
			this.formData.status = status;

			if (
				this.formData.admin_id.length > 0 &&
				Number(this.formData.admin_id) > 0
			) {
				console.log(this.formData.admin_id);
			} else {
				this.formData.admin_id = getUserId() ? getUserId() : 0;
			}

			this.$refs[formName].validate((valid) => {
				const that = this;
				if (valid) {
					that.formData.special_id = that.formData.special_id
						? that.formData.special_id[that.formData.special_id.length - 1]
						: that.formData.special_id;
					this.loading = isExit == 1;

					// 校验：如果之前有 AI 内容，现在被删空了，提示重新生成
					if (
						that.hasInitialAiContent &&
						(!that.formData.ai_content ||
							that.formData.ai_content.trim() === "")
					) {
						that.$message.warning("AI 解读内容不能为空，请重新生成");
						this.loading = false;
						return;
					}

					let tmpParam = { ...formData };
					if (!formData.url || formData.url.length == 0) {
						tmpParam.url = "9999";
					}
					addInformation(tmpParam)
						.then(async (res) => {
							if (res.code == 200) {
								that.$message.success("文章保存成功");

								// 保存成功后，如果有 AI 解读内容，则保存 AI 解读
								if (
									that.formData.ai_content &&
									that.formData.ai_content.trim() !== ""
								) {
									try {
										await saveAiAnalysis({
											information_id: res.data.id,
											ai_analysis: that.formData.ai_content,
										});
										that.$message.success("AI 内容保存成功");
									} catch (error) {
										console.error("AI 解读内容保存失败:", error);
										that.$message.warning("AI 内容保存失败，但文章已成功保存");
									}
								}

								// 所有保存操作完成后才关闭 loading
								this.loading = false;

								if (isExit == 1) {
									this.goBack();
								} else {
									// 更新路由，添加或更新id参数
									const query = { ...this.$route.query };
									query.id = res.data.id;

									// 检查是否需要更新路由，避免重复导航错误
									const isSameId =
										this.$route.query.id &&
										this.$route.query.id.toString() === res.data.id.toString();

									if (!isSameId) {
										this.$router.replace({ query });
									}
								}
							} else {
								this.loading = false;
								that.$message.error(res.message);
							}
						})
						.catch((error) => {
							that.$message.error(error);
							this.loading = false;
						});
				} else {
					that.$message.error("缺少必填参数，请根据提示填写！");
					return false;
				}
			});
		},
		// 新增 goBack 方法
		goBack() {
			// 优先使用 Vue Router 的 history 判断
			if (
				this.$router.history &&
				this.$router.history.stack &&
				this.$router.history.stack.length > 1
			) {
				console.log("使用 Vue Router 的 history 栈");
				this.$router.back();
			} else if (window.history.length > 1) {
				// 备用方案：使用浏览器原生 history API
				console.log("使用浏览器原生 history API");
				window.history.back();
			} else {
				// 没有历史记录，跳转到默认页面
				this.$router.push({ path: "/message/messagelist" });
			}
		},
		// 获取专题数据
		getspecialList() {
			var childNodes = [];
			const that = this;
			specialList({})
				.then((res) => {
					if (res.code == 200) {
						that.specialList = that.toTree(res.data.list);
						if (that.tmp_special_id != undefined && that.tmp_special_id != "") {
							that.formData.special_id = this.getParentsById(
								that.specialList,
								that.tmp_special_id,
							);
						}
					} else {
						that.$message.error(res.message);
					}
				})
				.catch((error) => {
					that.$message.error(error.message);
				});
		},
		// 获取资讯详情
		getInformationDetail() {
			const that = this;
			getInformationDetail({ id: that.$route.query.id })
				.then((res) => {
					if (res.code == 200) {
						for (let key in that.formData) {
							that.formData[key] = res.data[key];
						}

						that.getDefaultCate(that.formData.type);
						that.handlelanguageChange(that.formData.language);

						that.formData["id"] = res.data.id;
						that.formData.status = that.formData.status.toString();

						that.formData.prohibit_tran =
							that.formData.prohibit_tran.toString();
						that.formData.admin_id = that.formData.admin_id.toString();

						that.formData.language = that.formData.language
							? that.formData.language.toString()
							: that.formData.language;

						that.formData.category_id = that.formData.category_id
							? that.formData.category_id.toString()
							: that.formData.category_id;

						that.formData.type = that.formData.type
							? that.formData.type.toString()
							: that.formData.type;

						that.formData.is_home = that.formData.is_home.toString();

						that.formData.is_recommend = that.formData.is_recommend.toString();

						that.formData.is_top = that.formData.is_top.toString();

						that.formData.allow_tgpush = that.formData.allow_tgpush.toString();

						that.ticketArray = that.getLstInteger(that.formData.ticket_id);
						that.formData.label_id = that.formData.label_id
							? that.formData.label_id.toString()
							: that.formData.label_id;
						that.tmp_special_id = that.formData.special_id;
						that.formData.special_id = this.getParentsById(
							this.specialList,
							that.formData.special_id,
						);
						that.handletypeChange(that.formData.type, false);
						that.getUserType();
						if (that.formData.status == 0) {
							this.startAutoSaveTimer();
						}

						// 获取 AI 解读内容
						that.getAiAnalysisContent(res.data.id);
					} else {
						that.$message.error(res.message);
					}
				})
				.catch((error) => {
					that.$message.error(error.message);
				});
		},
		getParentsById(list, id) {
			for (let i in list) {
				if (list[i]["value"] == id) {
					return [list[i]["value"]];
				}
				if (list[i].children) {
					let node = this.getParentsById(list[i].children, id);
					if (node !== undefined) {
						// 追加父节点
						node.unshift(list[i]["value"]);
						console.log("node" + node);

						return node;
					}
				}
			}
		},
		getLstInteger(str) {
			let lStrTemp = [];
			console.log("getLstInteger:", str);

			str.split(",").map((u) => {
				lStrTemp.push(parseInt(u));
			});
			lStrTemp.splice(lStrTemp.length - 1, 1);
			return lStrTemp;
		},
		back() {
			this.$confirm("取消编辑将丢失已经修改的数据，确认取消编辑吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					// 判断是否有浏览历史可以返回
					if (window.history.length <= 1) {
						// 没有历史记录可返回，跳转到消息列表
						this.$router.push({ path: "/message/messagelist" });
					} else {
						// 有历史记录可返回，执行返回操作
						this.$router.back();
					}
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消返回",
					});
				});
		},
		clearFormAdd() {
			for (let key in this.formData) {
				this.formData[key] = "";
			}
			this.formData.prohibit_tran = "0";
			this.formData.allow_tgpush = "1";
			this.formData.is_top = "0";
			this.formData.is_home = "0";
			this.formData.is_push = "0";
			this.formData.is_recommend = "0";
			this.formData.status = "0";
			this.formData.edit_type = 1;
			this.formData.visits_num = 0;
		},

		getUserType() {
			if (this.formData.author_id && this.userList.length > 0) {
				for (let index = 0; index < this.userList.length; index++) {
					const element = this.userList[index];
					if (element.id == this.formData.author_id) {
						this.userType = element.userType.toString();
					}
				}
			}
			this.getUserSelList(this.userType);
		},

		getUserSelList() {
			this.userSelList = [];
			var userType = Number(this.userType);
			for (let index = 0; index < this.userList.length; index++) {
				const element = this.userList[index];
				if (element.userType == userType) {
					this.userSelList.push(element);
				}
			}
		},
		handleUserTypeChange(e) {
			this.getUserSelList(this.userType);

			this.formData.author_id = "";
		},

		getDefaultCate(e) {
			if (e == 2) {
				this.rule.pic = [{ trigger: "change", required: false }];
			} else {
				this.rule.pic = [
					{ validator: validateNull, trigger: "change", required: true },
				];
			}

			if (this.categoryList.length > 0 && this.formData.category_id) {
				this.categoryList_show = [];

				for (let index = 0; index < this.categoryList.length; index++) {
					const element = this.categoryList[index];
					// 快讯类型时过滤掉id=89，其他类型正常处理
					if (element.type == e && !(e == 2 && element.id == 89)) {
						this.categoryList_show.push(element);
					}
				}
			}
		},
		// 分类选择回调
		handletypeChange(e, setDefaults = true) {
			// 仅用户切换为专栏时默认展示，加载已有文章时保留原设置。
			if (setDefaults && e == 5) {
				this.formData.is_home = "1";
			}
			if (e == 2) {
				this.rule.pic = [{ trigger: "change", required: false }];
				this.rule.illustrate = [{ trigger: "change", required: false }];
			} else {
				this.rule.pic = [
					{ validator: validateNull, trigger: "change", required: true },
				];
				this.rule.illustrate = [
					{ validator: validateNull, trigger: "blur", required: true },
				];
				// 非快讯类型时，重置重要快讯标记
				this.formData.is_important_flash = 0;
			}
			this.categoryList_show = [];

			for (let index = 0; index < this.categoryList.length; index++) {
				const element = this.categoryList[index];
				// 快讯类型时过滤掉id=89，其他类型正常处理
				if (element.type == e && !(e == 2 && element.id == 89)) {
					// 只在新建时设置默认分类，编辑时保持原有分类
					if (
						this.categoryList_show.length == 0 &&
						!this.formData.category_id
					) {
						this.formData.category_id = element.id.toString();
					}
					this.categoryList_show.push(element);
				}
			}
		},
		handlelanguageChange(e) {
			if (e == 2) {
				this.rule.title = [{ trigger: "blur", required: false }];
				this.rule.illustrate = [{ trigger: "blur", required: false }];
				this.rule.content = [{ trigger: "blur", required: false }];

				this.rule.title_en = [
					{ validator: validateNull, trigger: "blur", required: true },
				];
				this.rule.illustrate_en = [
					{ validator: validateNull, trigger: "blur", required: true },
				];
				this.rule.content_en = [
					{ validator: validateNull, trigger: "blur", required: true },
				];
			} else {
				this.rule.title_en = [{ trigger: "blur", required: false }];
				this.rule.illustrate_en = [{ trigger: "blur", required: false }];
				this.rule.content_en = [{ trigger: "blur", required: false }];

				this.rule.title = [
					{ validator: validateNull, trigger: "blur", required: true },
				];
				this.rule.illustrate = [
					{ validator: validateNull, trigger: "blur", required: true },
				];
				this.rule.content = [
					{ validator: validateNull, trigger: "blur", required: true },
				];
			}
		},
		// 准备富文本编辑器
		onEditorReady(quill) {},
		//失去焦点事件
		onEditorBlur(quill) {
			// console.log("editor blur!", quill);
		},
		//获得焦点事件
		onEditorFocus(quill) {
			// console.log("editor focus!", quill);
		},
		//内容改变事件
		onEditorChange({ quill, html, text }) {
			if (this.formData.content !== html) {
				this.formData.content = html;
			}
		},
		// 生成AI内容
		async generateAIContent() {
			if (!this.formData.title || this.formData.title.trim() === "") {
				this.$message.warning("请先输入标题");
				return;
			}

			if (!this.formData.content) {
				this.$message.warning("请先编辑正文内容");
				return;
			}

			this.aiGenerating = true;

			try {
				const response = await generateAiAnalysis({
					title: this.formData.title,
					content: this.formData.content,
				});

				if (response.code === 200) {
					this.formData.ai_content = response.data.ai_analysis;
					this.$message.success("AI内容生成完成");
				} else {
					if (response.errors && response.errors.title) {
						this.$message.error("请先输入标题");
					} else if (response.errors && response.errors.content) {
						this.$message.error("请先编辑正文内容");
					} else {
						this.$message.error(response.message || "AI内容生成失败");
					}
				}
			} catch (error) {
				this.$message.error("AI内容生成失败：" + (error.message || "网络错误"));
			} finally {
				this.aiGenerating = false;
			}
		},
		// 获取AI解读内容（编辑时回填）
		async getAiAnalysisContent(informationId) {
			if (!informationId) {
				return;
			}

			try {
				const response = await getAiAnalysis({
					information_id: informationId,
				});

				if (response.code === 200 && response.data.has_ai_analysis) {
					this.formData.ai_content = response.data.ai_analysis || "";
					this.hasInitialAiContent = true; // 标记已有 AI 内容
					console.log("AI 解读内容回填成功");
				}
			} catch (error) {
				console.error("获取 AI 解读内容失败:", error);
			}
		},
	},
};
</script>

<style scoped>
.main {
	width: calc(100% - 40px);
}
.upload_img_div {
	display: flex;
}
.upload_img_del {
	margin-left: -15px;
	margin-top: -15px;
}
.upload_img_del img {
	width: 30px;
	height: 30px;
}
.add_main_new {
	width: 100%;
	height: calc(100vh - 140px);
	margin: 0 auto;
	display: flex;
	margin-top: 20px;
	padding-bottom: 20px;
}

.sub_content_left {
	margin-left: 10px;
	margin-right: 10px;
	width: 300px;
	border: 1px solid black; /* 添加边框 */
	padding: 20px; /* 可选：增加内边距使内容不紧贴边框 */
	border-radius: 4px; /* 可选：添加圆角使边框更美观 */
	overflow-y: scroll;
}
.sub_content_right {
	margin-left: 0%;
	margin-right: 20px;
	width: calc(100vw - 210px - 60px - 340px);
	border: 1px solid black; /* 添加边框 */
	padding: 20px; /* 可选：增加内边距使内容不紧贴边框 */
	border-radius: 4px; /* 可选：添加圆角使边框更美观 */

	overflow-y: scroll;
}
</style>
<style>
.el-card__body,
.el-main {
	padding-top: 0 !important;
}
.card_title {
	height: 40px;
}
</style>
<style scoped>
.loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
	display: flex;
	justify-content: center;
	align-items: center;
}

.spinner {
	/* 样式可以根据需求自行调整 */
	border: 4px solid rgba(255, 255, 255, 0.3);
	border-radius: 50%;
	border-top: 4px solid #fff;
	width: 50px;
	height: 50px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>

<style scoped>
.add_item_title {
	font-size: 18px;
	font-weight: 800;
}
</style>

<style>
.add_main_new .el-form-item__label {
	font-size: 16px;
	text-align: left;
	font-weight: 800;
	width: 90px !important;
}

.add_main_new .el-form-item__content {
	margin-left: 90px !important;
}

.add_main_item_block .el-form-item__content {
	margin-left: 0px !important;
}

.add_main_new .el-radio {
	margin-right: 10px;
}

.add_main_new .el-radio__label {
	font-size: 14px;
	padding-left: 4px;
}

.add_main_new .el-form-item {
	margin-bottom: 0px;
}
.add_main_new .el-input__inner {
	border: 1px solid #dcdfe6;
	border-radius: 5px;
}

.add_main_new .add_left_item_input {
	width: 200px;
}

.add_main_new .add_left_item_cascader {
	width: 290px;
	margin-top: 10px;
}
</style>
<style scoped>
.add_left_item_zhuanti {
	display: block;
	margin-top: 10px;
}

.add_left_item_zhuanti_header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.add_left_item_zhuanti_header_left {
	display: flex;
	align-items: baseline;
}

.add_left_item_zhuanti_header_left_title {
	font-size: 16px;
	font-weight: 800;
	margin-right: 6px;
}

.add_left_item_zhuanti_header_left_count {
	font-size: 12px;
	font-weight: 800;
	margin-right: 6px;
}

.add_left_item_zhuanti_header_right {
	border: 1px solid #dcdfe6;
	width: 40px;
	border-radius: 10px;
	text-align: center;
	font-size: 20px;
	align-items: center;
	align-content: center;
	margin-right: 10px;
}

.add_left_submit {
	margin-left: 0 !important;
	margin-top: 20px;
}
.add_main_item_block {
	display: flex;
	flex-direction: column;
}

.add_main_item_block_img {
	display: block;
}
.add_main_item_block_img_text {
	margin-top: 10px;
	font-size: 12px;
	line-height: 20px;
	display: flex;
}

.upload_img_div_add {
	width: 100%;
	aspect-ratio: 16/9;
	border: 1px solid #dcdfe6;
	border-radius: 6px;
	align-content: center;
	align-items: center;
	text-align: center;
}

.upload_img_div_add img {
	width: 40px;
	height: 40px;
	object-fit: cover;
}

.add_main_editor {
	margin-top: 20px;
	height: calc(100vh - 210px);
}

.add_left_item_zhuanti_content {
	border: 1px solid #dcdfe6;
	border-radius: 5px;
	/* height: 36px; */
	padding: 10px 10px;
	margin-right: 10px;
	margin-top: 10px;
	text-align: center;
	align-content: center;
	font-size: 14px;
	font-weight: 600px;
}

.form_tip {
	font-size: 12px;
	color: #999;
	margin-top: 5px;
	margin-bottom: 0;
}

.business-category-group .el-radio {
	margin-bottom: 10px;
	line-height: 1.5;
}

.ai_analysis_section {
	margin-top: 20px;
}

.ai_analysis_header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
	position: relative;
	z-index: 1;
}

.ai_analysis_header .el-button {
	cursor: pointer;
	pointer-events: auto;
}

.ai_analysis_title {
	font-size: 16px;
	font-weight: 800;
	pointer-events: none;
}

.ai_content_placeholder {
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	padding: 20px;
	text-align: center;
	color: #999;
	background-color: #f5f7fa;
}

.ai_content_editor {
	width: 100%;
}
</style>
<style>
.add_left_item_zhuanti_dialog .el-dialog {
	display: block;
	background: rgba(0, 0, 0, 0) !important;
}

.add_left_item_zhuanti_dialog .el-dialog__header {
	display: none;
}

.add_left_item_zhuanti_dialog .el-dialog__body {
	padding: 0;
	background: rgba(0, 0, 0, 0);
}
</style>
